let labelElement;

function waitForElm(selector) {
  return new Promise((resolve) => {
    const element = document.querySelector(selector);
    if (element) {
      return resolve(element);
    }

    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

function checkInput() {
  if (this.value) {
    labelElement.classList.add('has-text');
    this.classList.add('has-text');
  } else {
    labelElement.classList.remove('has-text');
    this.classList.remove('has-text');
  }
}

waitForElm('label.kl-private-reset-css-Xuajs1').then((element) => {
  labelElement = element;
});

waitForElm('input.kl-private-reset-css-Xuajs1').then((inputElement) => {
  inputElement.addEventListener('input', checkInput);
});